module.exports = __webpack_public_path__ + "img/解决方案_EMS_灰.f5dc03c5.svg";